import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { categories, cities, countries } from '../../utils/select-options';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { LogService } from '../../../core/services/log.service';

@Component({
  selector: 'app-filters',
  standalone:true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatIconModule
  ],
  templateUrl: './filters.html',
  styleUrl: './filters.scss'
})
export class Filters {
  @Output() filtersChanged = new EventEmitter<any>();

  constructor(private logger: LogService) {}

  filters = {
    category: '',
    minRating: 0,
    city:'',
    country:'',
    sortBy: 'pertinence',
    nearMe: false,
    radiusKm: 10,
    latitude: null as number | null,
    longitude: null as number | null,
    order: 'desc'
  };
  categories = categories.sort();
  cities = cities;
  countries = countries;

  applyFilters() {
    this.filtersChanged.emit(this.filters);
  }

  resetFilters() {
    this.filters = {
      category: '',
      minRating: 0,
      city:'',
      country:'',
      sortBy: '',
      nearMe: false,
      radiusKm: 10,
      latitude: null as number | null,
      longitude: null as number | null,
      order: 'asc'
    };
    this.applyFilters();
  }

  checkGeolocation(){
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.filters.latitude = pos.coords.latitude;
          this.filters.longitude = pos.coords.longitude;
        },
        (error) => {
          this.filters.nearMe = false;
          alert('Veuillez autoriser la géolocalisation pour utiliser cette fonctionnalité.');
          this.logger.error('Géolocalisation refusée: ' + JSON.stringify(error));
        }
      );
    } else {
      alert('La géolocalisation n\'est pas supportée par votre navigateur.');
      this.filters.nearMe = false;
      this.logger.warn('Géolocalisation non supportée');
    }
  }

  toggleOrder() {
    this.filters.order = this.filters.order === 'asc' ? 'desc' : 'asc';
    this.applyFilters();
  }
}
